import { Card } from 'antd';
import PageTitle from '../../components/page-title';
import { AddMembersForm } from '../../components/add-members-modal';
import { addMembersToClan, searchClanOptions } from '../domestic-manager/api';

// Trang cũ /domestic-user — giữ cho link/bookmark cũ. Cách nhanh hơn: nút "Thêm thành viên"
// ngay trên từng dòng ở trang Nhóm quản lý hoặc trong trang Chi tiết nhóm.
function AddUserDomesticManager() {
  return (
    <div>
      <PageTitle title="Thêm thành viên nhóm" />
      <Card style={{ maxWidth: 640 }}>
        <AddMembersForm
          targetLabel="Nhóm quản lý"
          targetPlaceholder="Gõ tên nhóm"
          fetchTargets={searchClanOptions}
          userLabel="Thành viên"
          submitText="Thêm vào nhóm"
          onSubmit={(userIds, groupId) => addMembersToClan(groupId, userIds)}
        />
      </Card>
    </div>
  );
}

export default AddUserDomesticManager;
